export default function Collectorprofile() {
  return <section id="collector-profile">
    
  </section>;
}
